export default "__VITE_ASSET__BZpYSIRb__"